import { Controller } from "@hotwired/stimulus"

// Mirrors YoutubeUrlValidator::YOUTUBE_REGEX in
// app/models/concerns/youtube_url_validator.rb -- keep the two in sync.
const YOUTUBE_REGEX = /https?:\/\/(?:(?:www|m)\.)?(?:youtu\.be\/|youtube\.com\/(?:live|shorts|embed|v)\/|youtube\.com\/watch\?(?:[^&\s]+&)*v=)([A-Za-z0-9_-]+)/

export default class extends Controller {
  static get targets () {
    return [
      "VideoUrl",
      "VideoUrlError",
      "VideoContainer",
      "VideoIframe",
      "SrcDocContainer"
    ]
  }

  get minutesController() {
    var elem = document.getElementById(`item-minutes-${this.itemId}`)
    return this.application.getControllerForElementAndIdentifier(elem, "item-minutes")
  }

  initialize() {
    this.formUrl = this.data.get('formUrl')
    this.itemId = this.data.get("itemId")
    this.videoUrl = this.VideoUrlTarget.value
    this.youtubeId = this.VideoIframeTarget.dataset.youtubeId
    this.updateVideoStyle()
    this.setIframeSrcAndSrcDoc()
    this.onVideoUrlChange = debounce(this.onVideoUrlChange.bind(this), 250)
  }

  updateVideoStyle() {
    if (this.videoUrl !== "") {
      this.VideoContainerTarget.classList.remove("hidden")
    } else {
      this.VideoContainerTarget.classList.add("hidden")
    }
  }

  setIframeSrcAndSrcDoc() {
    var embedUrl = this.youtubeEmbedUrl(this.videoUrl)

    // Not a YouTube URL we can parse -- leave the preview empty rather than
    // pointing the iframe at /embed/undefined.
    if (!embedUrl) {
      this.VideoIframeTarget.removeAttribute("srcdoc")
      this.VideoIframeTarget.removeAttribute("src")
      return
    }

    this.youtubeId = this.youtubeIdFromUrl(this.videoUrl)
    var autoplayUrl = `${embedUrl}${embedUrl.includes("?") ? "&" : "?"}autoplay=1`
    var srcDoc = `<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href="${autoplayUrl}"><img src="https://img.youtube.com/vi/${this.youtubeId}/0.jpg"><span>&#x25BA;</span></a>`
    this.VideoIframeTarget.srcdoc = srcDoc
    this.VideoIframeTarget.src = embedUrl
  }

  onVideoUrlChange(event) {
    fetch(this.formUrl, {
      method: "PUT",
      credentials: "same-origin",
      headers:  {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ item: { video_url: event.target.value }})
    })
      .then(response => response.json())
      .then(response => {
        if (response.errors) {
          this.VideoUrlErrorTarget.innerHTML = `URL ${response.errors.video_url[0]}`
          this.VideoUrlTarget.classList.add("border-red-600")
          this.VideoContainerTarget.classList.add("hidden")
          this.VideoUrlErrorTarget.classList.remove("hidden")
        } else {
          this.videoUrl = response.video_url
          if (this.videoUrl !== "") {
            this.youtubeId = this.youtubeIdFromUrl(this.videoUrl)
            this.setIframeSrcAndSrcDoc()
          }
          this.VideoUrlTarget.classList.remove("border-red-600")
          this.VideoUrlErrorTarget.classList.add("hidden")
          this.updateVideoStyle()
          this.minutesController.updateSummaryWithResponse(response)
        }
      })
      .catch(console.error)
  }

  // Handles every share form: watch?v=, youtu.be/, /live/, /shorts/, /embed/.
  // The old version only read the `v` query param, so a youtu.be or a
  // /live/ link (what YouTube hands you for a streamed meeting) produced
  // an undefined id and a blank preview.
  youtubeIdFromUrl(yt_url) {
    var match = YOUTUBE_REGEX.exec((yt_url || "").replace(/\s+/g, ""))
    return match ? match[1] : null
  }

  youtubeStartSeconds(yt_url) {
    var match = /[?&](?:t|start)=(\d+)s?(?:&|$)/.exec(yt_url || "")
    return match ? match[1] : null
  }

  youtubeEmbedUrl(yt_url) {
    var id = this.youtubeIdFromUrl(yt_url)
    if (!id) { return "" }

    var start = this.youtubeStartSeconds(yt_url)
    return `https://www.youtube.com/embed/${id}${start ? `?start=${start}` : ""}`
  }

}